// components/CollectionDesc.tsx
import cn from 'classnames'
import React from 'react'
import { SHOW_COLLECTIONS_FOR_ALL } from 'src/config/config'

interface CollectionDescProps {
  className?: string
}

const CollectionDesc: React.FC<CollectionDescProps> = ({ className }) => {
  return (
    <div className={cn(className, SHOW_COLLECTIONS_FOR_ALL == 'true' ? 'mb-[72px]' : 'mb-12')}>
      <div className="w-full">
        <div className={cn('flex flex-row sm:px-0 justify-center')}>
          <div
            className={cn(
              '!max-w-[1100px] w-full flex md:flex-row flex-col py-2 md:pl-[0rem] pl-[1.25rem] pr-[1.25rem]',
              SHOW_COLLECTIONS_FOR_ALL == 'true' ? ' md:mt-[7px]' : ' md:mt-[0.9375rem]',
            )}
          >
            <div className={cn('flex !max-w-[800px]', 'flex-row', className)}>
              <p
                className={cn(
                  SHOW_COLLECTIONS_FOR_ALL == 'true'
                    ? 'text-[#333333] text-[18px] font-normal font-primary'
                    : 'blog-content',
                )}
              >
                Browse across dedicated collections of content on hot topics, or content that has been especially
                developed for specific personas.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CollectionDesc
